/**
 * 檢查或取代斜線
 * @typedef {Object} filterSlash
 * @property {string} text - 檢查的字串
 * @property {boolean} isReplace - 是否要取代
 * @property {string} replaceText - 取代後的問字
 * @returns {boolean|string} 若只有檢查返回布林值 ( 有斜線返回 true )，若有取代返回字串
 */
export const filterSlash = (text = '', isReplace = false, replaceText = '') => {
    if (typeof text !== 'string') return false;
    const reg = /[/\\]+/g;

    if (isReplace) return text.replace(reg, replaceText);
    else {
        if (reg.test(text)) return true;
        else return false;
    }
};

/**
 * Filter out the keys with values that are undefined or null from the input object
 * @typedef {Object} filterUndefinedOrNull
 * @property {string} obj - 要過濾的的物件
 */
export const filterUndefinedOrNull = obj => {
    if (!obj || typeof obj !== 'object') return {};
    if (Object.keys(obj).length === 0) return obj;

    for (const key in obj) {
        if (obj[key] === undefined || obj[key] === null) {
            delete obj[key];
        }
    }
    return obj;
};

/**
 * To extract the UUID from a nested object structure
 */
export const extractUUIDs = obj => {
    const uuids = [];
    function traverse(o) {
        for (const key in o) {
            if (o.hasOwnProperty(key)) {
                if (key === 'uuid' && typeof o[key] === 'string') {
                    uuids.push(o[key]);
                } else if (typeof o[key] === 'object' && o[key] !== null) {
                    traverse(o[key]);
                }
            }
        }
    }
    traverse(obj);
    return uuids;
};
